/**
 * File: DrawController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import imagePopup from '../views/popup/imagePopup.html'
import passagePopup from '../views/popup/passagePopup.html'
class DrawController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state,CONSTANTS, CQuesConst,$mdDialog,uploadService,$mdMedia) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Archives"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        //On destroy function
        this.$onDestroy = () => {
        }
         /********** BASIC DETAILS *********/
         let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
         let userId = localStorageService.get("user_id")
         let USER_PATH = userId + "/question/"
         let schoolId = localStorageService.get("school_id")
         let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
         $scope.fileUrl=PREVIEW_URL
         let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
         let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
         let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
         let SAVE_URL = CQuesConst.API_CREATE_DRAW
         $scope.questionImage = [];
         $scope.content_editor_id = userId;
 
         /******* LIMIT FOR QUSTION CREATION *******/
         $scope.option_limit = CQuesConst.OPTION_LIMIT;
         $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;
 
         //SET UI FOR EDIT QUESTIONS
         let editQuestion = $scope.$parent.$parent.editQuestion
         if (editQuestion) {
            $scope._id = editQuestion._id;
            $scope.question = editQuestion.qn_desc;
            $scope.questionImg = [];
            if (editQuestion.questionImg) {
                if (!Array.isArray(editQuestion.questionImg)) {
                    $scope.questionImg = editQuestion.questionImg
                } else {
                    $scope.questionImg.push(editQuestion.questionImg)
                }
                _.defer(() => { $scope.$apply() })
            }   
          }
 
         //Image upload for question
        $scope.questionImgUpload = function (file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function (fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                    uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                        if (result.url) {
                            $scope.questionImage.push(result.url)
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }
            //DIALOG CONTROLLER FOR IMAGE
         var imageDialogCtrl = function ($scope, $mdDialog, imageViewType, imageDetails) {
             $scope.fileUrl = PREVIEW_URL
             $scope.isPassage = false;
             $scope.title = imageDetails.title;
             $scope.imageArray = imageDetails.images;
             $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false
 
             $scope.deleteImage = function (imageIndex) {
                 $scope.imageArray.splice(imageIndex, 1)
             }
             $scope.cancelDialog = function () {
                 $mdDialog.cancel();
                 if (imageViewType === 'question') {
                     $scope.questionImage = $scope.imageArray
                 } else if (imageViewType === 'explan') {
                     $scope.explanationImage = $scope.imageArray
                 } else if (imageViewType === 'answer') {
                     $scope.descImage = $scope.imageArray
                 }
                 $scope.imageArray = []
             };
         }
 
         //Open dialog to view image
         $scope.openDialog = (imageType) => {
             let imageDetails;
             if (imageType === 'question') {
                 imageDetails = {
                     title: "Drawing - Question Image",
                     images: $scope.questionImage
                 }
                }
             var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
             $mdDialog.show({
                 locals: {
                     imageViewType: imageType,
                     imageDetails: imageDetails
                 },
                 template: imagePopup,
                 controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
                 parent: angular.element(document.body),
                 clickOutsideToClose: true,
                 fullscreen: useFullScreen
             })
         }
 
         //DIALOG CONTROLLER FOR PASSAGE
         var passageDialogCtrl = function ($scope, $mdDialog, passages) {
             $scope.passages = passages
             /*
              * Function to cancel dialog to select passage
              */
             $scope.cancelPassage = function () {
                 $mdDialog.cancel();
             };
 
 
             /*
              * Function to select passage
              */
             $scope.selectPassage = function (passage_id) {
                 _.each($scope.passages, function (eachPas) {
                     if (eachPas._id === passage_id) {
                         if (eachPas.isSelected)
                             $scope.selectedPassage = eachPas;
                         else
                             $scope.selectedPassage = null
                     } else {
                         eachPas.isSelected = false;
                     }
                 })
                 $scope.cancelPassage()
             }
 
             /*
              * Function to cancel select passage
              */
             $scope.cancelSelectedPasssage = function () {
                 $scope.selectedPassage = null
             }
 
         }
 
         //TO SET PASSAGE LIST
         var passageCallback = (resultObj) => {
             let isPassagePresent = false;
             if (resultObj && resultObj.result && resultObj.result.data) {
                 var result = resultObj.result.data.passage ? resultObj.result.data.passage : []
                 if (result) {
                     if (result.length > 0) {
                         isPassagePresent = true;
                         _.each(result, function (eachPas) {
                             if ($scope.selectedPassage && $scope.selectedPassage._id === eachPas._id) {
                                 eachPas["isSelected"] = true
                             } else {
                                 eachPas["isSelected"] = false
                             }
                         })
                         var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                         $mdDialog.show({
                             locals: {
                                 passages: result
                             },
                             template: passagePopup,
                             controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                             parent: angular.element(document.body),
                             clickOutsideToClose: true,
                             fullscreen: useFullScreen
                         })
                     }
                 }
             }
             if (!isPassagePresent) {
                 $mdDialog.show(
                     $mdDialog.alert()
                         .clickOutsideToClose(true)
                         .title('No Passage')
                         .textContent('No passages added yet. Please add passage and link it')
                         .ariaLabel('Passage Dialog')
                         .ok('Ok')
                 );
             }
         }
 
 
         /*
          * Function to open dialog to select passage
          */
         $scope.openPassage = () => {
             let authoring = {
                 curriculum_id: $scope.$parent.curriculum_id,
                 class_id: $scope.$parent.class_id,
                 subject_id: $scope.$parent.subject_id,
                 school_id: schoolId
             }
             $scope.fileUrl = PREVIEW_URL
             $scope.isArray = function (obj) {
                 return Array.isArray(obj);
             }
             authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback)
         }
 
         //Adding OWQ question from UI
         $scope.$on('addDrawing', function () {
             $scope.errors = {}
             let details = localStorageService.get("questionDetails")
             let question = details.question
             let activityErrorCount = details.errorCount;
             //Validation 

      if ($scope.question == null || $scope.question == undefined || $scope.question == "") {
            $scope.errors.qn_desc = "Question is required";
            $scope.activityErrorCount++;
          }
      if ($scope.questionImg == null || $scope.questionImg == undefined || $scope.questionImg == "") {
        $scope.errors.questionImg = "Image is required";
        $scope.activityErrorCount++;
        }
             if (activityErrorCount === 0) {
                $scope.$parent.isSaveClicked = true;
                 let obj = {
                     "_id": $scope._id,
                     "question_theme_id": question.theme._id,
                     "question_theme_name": question.theme.name,
                     "strand": question.strand,
                     "tag": question.tag,
                     "wave": question.wave,
                     "qn_desc": '' + $scope.question,
                     "isLatex": $scope.isLatex,
                     "level": question.level,
                     "subject_id": question.subject_id,
                     "school_id": question.school_id,
                     "questionImg": $scope.questionImage,
                     "session_id": question.session_id,
                     "batch_id": question.batch_id,
                     "class_id": question.class_id,
                     "curriculum_id": question.curriculum_id,
                     "xlink": question.link_theme,
                     "cognitive_skills": question.cognitive_skill,
                     "isNotAddToQp": question.isNotAddToQp,
                     "is_traditional_activity": question.is_traditional_activity,
                     "qp_id": question.qp_id,
                     "activity_id": question.activity_id,
                     "user_id": userId,
                     "created_dt": $scope.created_dt,
                     "content_editor_id": $scope.content_editor_id
                 }
                 //SAVE CALL
                 authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                     let result = resObj.result
                     if (result && result.data && result.data.success) {
                         $rootScope.setHideSaveButton(false)
                         $rootScope.setLoader(false)
                         $rootScope.resetValues()
                         if (question.is_traditional_activity) {
                             $state.go('formatQuestion', {
                                 qpId: question.qp_id
                             })
                             toastr.success("Question Saved successfully");
                         } else {
                             if(result.data.isExists){
                                 toastr.success("Question already exists");
                             }else{
                                 toastr.success("Question Saved successfully");
                                 $rootScope.setSearchFieldSession()
                             }
                         }
                     } else {
                         $rootScope.setHideSaveButton(false)
                         $rootScope.setLoader(false)
                         toastr.error("Network Error")
                     }
                     _.defer(() => { $scope.$apply() })
                 })
             } else {
                 $rootScope.setHideSaveButton(false)
                 $rootScope.setLoader(false)
                 toastr.error("Please fill all mandatory fields")
             }
         })

    }
}

export default DrawController;


// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/drawController.js